"use client"

import clsx from "clsx"
import { useSidebar } from "./useSidebar"
import useOutsideClick from "@/hooks/useOutsideClick"
import { Notifications } from "../Notifications"
import { IconButton } from "@/elements"
import { XMarkIcon } from "@heroicons/react/24/outline"
import type { NovaSession } from "@/types"

interface Props {
  serverSession: NovaSession
}

const id = "secondary-sidebar"

export const SecondarySidebar: React.FC<Props> = ({ serverSession }) => {
  const { secondaryBar, closeSecondaryBar } = useSidebar()

  useOutsideClick(id, () => {
    closeSecondaryBar()
  })

  return (
    <div
      id={id}
      style={{
        zIndex: 70,
      }}
      className={clsx(
        "fixed top-0 order-2 h-dvh overflow-hidden bg-bg-1 shadow-lg duration-200 ease-in-out md:left-[96px] md:h-full",
        secondaryBar.open ? "translate-x-0 transform opacity-100" : "-translate-x-full transform opacity-0"
      )}>
      <div
        className={clsx(
          "h-full w-screen border-bg-2 transition-opacity duration-300 ease-in-out md:w-[419px]",
          secondaryBar.open ? "border-r opacity-100" : "border-0 opacity-0"
        )}>
        <div className="h-full w-full overflow-auto">
          <div className="absolute right-2 top-2 z-10 h-10 w-10 shrink-0">
            <IconButton Icon={XMarkIcon} onClick={closeSecondaryBar} variant="white" />
          </div>
          <Notifications serverSession={serverSession} isOpen={secondaryBar.open} />
        </div>
      </div>
    </div>
  )
}
